//存放常量-全局管理
export const SET_NAV_INFO = "set_nav_info";
export const SET_USER_INFO = "set_user_info";
export const SET_ROOT_ID_INFO = "set_root_id_info";
export const SET_SHOW_HIDDEN = "set_show_hidden";
export const SET_ROLERS_SOURCEINFO = "set_roles_sourceinfo";
export const SET_MEMBER_INFO = "set_member_info";
